<template>
  <div class="py-3">
    <v-form ref="form" @submit.stop.prevent>
      <v-row>
        <v-col cols="12" sm="4" md="3" lg="2">
          <v-text-field
            type="number"
            v-model.trim="editedSettings.hotel"
            :label="$t('tenantSettings.defaultHotelValue')"
            min="0"
            prepend-icon="mdi-card-text-outline"
            tabindex="1"
            clearable
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="4" md="3" lg="2">
          <v-text-field
            type="number"
            v-model.trim="editedSettings.diet"
            :label="$t('tenantSettings.defaultDietValue')"
            min="0"
            prepend-icon="mdi-card-text-outline"
            tabindex="1"
            clearable
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="4" md="3" lg="2">
          <v-checkbox
            v-model="editedSettings.generateProjectNumber"
            :label="$t('tenantSettings.generateProjectNumber')"
            :disabled="!hasAccess()"
            tabindex="1"
          ></v-checkbox>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="4" md="3" lg="2">
          <v-btn
            v-if="hasAccess()"
            :disabled="!isModelChanged()"
            tabindex="2"
            class="mt-3"
            color="primary"
            @click="saveChanges">
            {{ $t('save') }}
          </v-btn>
        </v-col>
      </v-row>
    </v-form>
  </div>
</template>


<script>
import { mapActions } from 'vuex'

import pageMixin from '@/mixins/page.mixin'
import snackbarMixin from '@/mixins/snackbar.mixin'
import objectMixin from '@/mixins/object.mixin'
import unsavedChangesMixin from '@/mixins/unsavedChanges.mixin'
import accessMixin from '@/mixins/access.mixin'


export default {
  mixins: [
    pageMixin,
    snackbarMixin,
    objectMixin,
    unsavedChangesMixin,
    accessMixin
  ],


  data () {
    return {
      editedSettings: {}
    }
  },


  methods: {
    ...mapActions('settings', ['loadSettings', 'updateSettings']),

    async saveChanges () {
      if (!this.isModelChanged()) return

      try {
        this.showSnackbarProcessing()
        const settings = this.getObjectCopy(this.editedSettings)
        await this.updateSettings(settings)
        this.initWatchedModel(this.editedSettings)
        this.showSnackbarSuccess(this.$t('tenantSettings.settingsUpdated'))
      } catch (error) {
        this.showSnackbarError()
        this.$log.error(error)
      }
    }
  },


  async created () {
    try {
      this.startPageLoading()
      const settings = await this.loadSettings()
      this.editedSettings = this.getObjectCopy(settings)
      this.initWatchedModel(this.editedSettings)
    } catch (error) {
      this.showSnackbarError()
      this.$log.error(error)
    } finally {
      this.stopPageLoading()
    }
  }
}
</script>
